import { z } from 'zod';
import { SSN_REGEX, BIRTHDATE_REGEX } from 'constants/patterns';

export const SSN_SCHEMA = z
  .string()
  .min(9, { message: 'error.validation.invalidValue' })
  .max(11, { message: 'error.validation.invalidValue' })
  .regex(SSN_REGEX, { message: 'error.validation.invalidValue' });

export const DOB_SCHEMA = z
  .string()
  .length(10, { message: 'error.validation.invalidValue' })
  .regex(BIRTHDATE_REGEX, { message: 'error.validation.invalidValue' });
